/* FOLLIVA — fl-hr-* landing sections: before/after slider, looping carousel, card rail, review "show more"
   and "helpful" thumb.
   Every section includes this file, so the body only runs once; the editor re-inits on section load. */
(function () {
  'use strict';
  if (window.FLHR) return;

  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

  /* ---- before / after: a transparent range input drives --pos ---- */
  function initCompare(root) {
    each(root, '[data-fl-hr-ba]', function (el) {
      if (el.__flhr) return; el.__flhr = true;
      var range = el.querySelector('input[type="range"]');
      if (!range) return;
      var apply = function () { el.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', apply);
      apply();
    });
  }

  /* ---- looping carousel: slides are rendered 3x (clone | real | clone); after the scroll settles
     on a clone we jump to its real twin without animation, so arrows never hit an end ---- */
  function initCarousel(root) {
    each(root, '[data-fl-hr-car]', function (car) {
      if (car.__flhr) return; car.__flhr = true;
      var track = car.querySelector('[data-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var n = parseInt(car.getAttribute('data-count') || slides.length, 10);
      var loop = slides.length === n * 3;
      var dots = Array.prototype.slice.call(car.querySelectorAll('[data-dot]'));
      var counter = car.querySelector('[data-current]');
      var idx = loop ? n : 0, raf = 0, settle = 0;

      function leftFor(i) { var s = slides[i]; return s ? s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2 : 0; }
      function go(i, smooth) { track.scrollTo({ left: leftFor(i), behavior: smooth ? 'smooth' : 'auto' }); }
      function nearest() {
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
        slides.forEach(function (s, i) { var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid); if (d < bestD) { bestD = d; best = i; } });
        return best;
      }
      function paint() {
        raf = 0;
        idx = nearest();
        var real = ((idx % n) + n) % n;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === real); d.setAttribute('aria-current', i === real ? 'true' : 'false'); });
        if (counter) counter.textContent = (real < 9 ? '0' : '') + (real + 1);
      }
      function normalize() {
        if (!loop) return;
        var i = nearest();
        if (i < n || i >= n * 2) { go(n + (((i % n) + n) % n), false); paint(); }
      }
      track.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(paint);
        clearTimeout(settle); settle = setTimeout(normalize, 140);
      }, { passive: true });
      each(car, '[data-prev]', function (b) { b.addEventListener('click', function () { go(idx - 1, true); }); });
      each(car, '[data-next]', function (b) { b.addEventListener('click', function () { go(idx + 1, true); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go((loop ? n : 0) + i, true); }); });
      window.addEventListener('resize', function () { go(idx, false); paint(); });
      requestAnimationFrame(function () { go(idx, false); paint(); });
    });
  }

  /* ---- simple rail (phone testimonial cards): arrows scroll one card, dots follow ---- */
  function initRail(root) {
    each(root, '[data-fl-hr-rail]', function (wrap) {
      if (wrap.__flhr) return; wrap.__flhr = true;
      var rail = wrap.querySelector('[data-rail]');
      if (!rail) return;
      var cards = Array.prototype.slice.call(rail.children);
      var dots = Array.prototype.slice.call(wrap.querySelectorAll('[data-dot]'));
      function current() {
        var mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, bestD = Infinity;
        cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bestD) { bestD = d; best = i; } });
        return best;
      }
      function to(i) { var c = cards[Math.max(0, Math.min(cards.length - 1, i))]; if (c) rail.scrollTo({ left: c.offsetLeft - (rail.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' }); }
      rail.addEventListener('scroll', function () {
        var i = current();
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
      each(wrap, '[data-prev]', function (b) { b.addEventListener('click', function () { to(current() - 1); }); });
      each(wrap, '[data-next]', function (b) { b.addEventListener('click', function () { to(current() + 1); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { to(i); }); });
    });
  }

  /* ---- review widget: reveal the hidden reviews ---- */
  function initMore(root) {
    each(root, '[data-fl-hr-more]', function (btn) {
      if (btn.__flhr) return; btn.__flhr = true;
      btn.addEventListener('click', function () {
        var box = btn.closest('[data-fl-hr-reviews]');
        if (!box) return;
        each(box, '[data-extra]', function (el) { el.hidden = false; });
        btn.parentNode.hidden = true;
      });
    });
  }

  /* ---- review "helpful" thumb: tap turns it blue, tap again undoes ---- */
  function initHelpful(root) {
    each(root, '[data-fl-hr-helpful]', function (btn) {
      if (btn.__flhr) return; btn.__flhr = true;
      btn.addEventListener('click', function () {
        var on = !btn.classList.contains('is-active');
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  function init(root) { initCompare(root); initCarousel(root); initRail(root); initMore(root); initHelpful(root); }
  window.FLHR = { init: init };
  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
